import React from 'react'
import { Icon, Button } from '@pandiafi/design-system'
import { ListGroup, ListGroupItem } from '@pandiafi/components'
import { useTranslation } from 'react-i18next'

import { BulletinBoardResponse } from '../../../common/validations'

import { BulletinDetails } from 'components/Bulletin/components/BulletinDetails/BulletinDetails'
import { StyledLink } from 'components/StyledLink/StyledLink'
import { Error } from 'components/Error'
import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'

type BulletinBoardListItem = BulletinBoardResponse['bulletins'][0]

interface BulletinBoardListProps {
  bulletins: BulletinBoardListItem[]
  hasNextPage: boolean
  onLoadMore: () => void
}

export const BulletinBoardList: React.FC<BulletinBoardListProps> = ({
  bulletins,
  hasNextPage,
  onLoadMore,
}) => {
  const { t } = useTranslation(['common', 'bulletins'])
  const { bulletinBoardBulletinPath } = useContractPaths()

  if (!bulletins.length) {
    return (
      <Error
        illustration="empty-letter"
        message={t('bulletins:errors.noBulletins')}
      />
    )
  }

  return (
    <div className="flex flex-col gap-6">
      <ListGroup>
        {bulletins.map((bulletin) => (
          <ListGroupItem
            key={bulletin.uuid}
            content={
              <div className="flex flex-col gap-1">
                <StyledLink
                  to={bulletinBoardBulletinPath.replace(
                    ':bulletinUuid',
                    bulletin.uuid
                  )}
                >
                  {bulletin.title}
                </StyledLink>
                <BulletinDetails
                  publishedAt={bulletin.publishedAt}
                  updatedAt={bulletin.updatedAt ?? null}
                  author={bulletin.author}
                />
              </div>
            }
            actions={
              <Icon
                icon="angle-right"
                size="sm"
                className="text-common-gray-7"
              />
            }
          />
        ))}
      </ListGroup>
      {hasNextPage && (
        <Button
          variant="secondary"
          onClick={onLoadMore}
          className="self-center"
        >
          {t('common:showMore')}
        </Button>
      )}
    </div>
  )
}
